import '@updater-components/icon';
import { IS_DEMO } from '@updater-core/lib/environment';
import template from './home-services.html';
import './home-services.global.css';

const FAKE_PHONE_NUMBER = '888-555-5555';
const REAL_PHONE_NUMBER = '888 394-0560';

class HomeServicesController {
  phoneNumber = IS_DEMO ? FAKE_PHONE_NUMBER : REAL_PHONE_NUMBER;
}

export const HomeServicesComponent = {
  controller: HomeServicesController,
  template,
};
